import axios from 'axios'
const config = require('../../config');
import color from 'color';

const state = {
  events: []
}

const getters = {
  getEvents: state => state.events
}

const mutations = {
  setEvents: (state, events) => {
    state.events = events
  }
}

const actions = {
  async fetchEvents({ commit }, eiids) {
      let locale = this.getters.getLocale != null ? this.getters.getLocale : 'ro';
      const resp = await axios.post(`${config.baseUrl}?address=/spring/api/1.0.0/events&eIds=${eiids}&lang=${locale}`);
      try {
        if (resp.data.result == 1){
          resp.data.data.sort((a, b) => {
            return eiids.indexOf(a.id) - eiids.indexOf(b.id);
          });
          commit('setEvents', resp.data.data);
        }
      } catch (error) {
        console.log(error);
      }
  },
  async getSection(_, eiId) {
    const resp = await axios.post(`${config.baseUrl}?address=/spring/api/1.0.0/instance/seats&id=${eiId}`);
    try {
      if (resp.data.result == 1){
        resp.data.data.venue = getDataFromMin(resp.data.data.venue);
        const priceCatDefs = resp.data.data.venue.priceCatDefs.map((pcd) => {
          return {
            ...pcd,
            labelColor: color(pcd.color).contrast(color('#111')) > 3 ? '#111' : '#fff',
            backgroundColor: pcd.color,
            borderColor: pcd.color,
            found: false,
            stats: {
              total: 0,
              free: 0
            }
          };
        });
        
        // Convert the array into an object keyed by 'id'
        const priceCatDefsById = {};
        priceCatDefs.forEach((pcd) => {
          priceCatDefsById[pcd.id] = pcd;
        });
        resp.data.data.venue.priceCatDefs = priceCatDefsById;
        
        return resp.data.data;
      }
    } catch (error) {
      console.log(error);
      return null;
    }
  },
  async getEventInstancePrices( _ , eiId) {
    const resp = await axios.post(`${config.baseUrl}?address=/spring/api/1.0.0/instance/prices&id=${eiId}&showSeats=false`);
    try {
      if (resp.data.result == 1){
        return resp.data.data;
      }
    } catch (error) {
      console.log(error);
    }
  },
}

function getDataFromMin (data) {
  // data = data.venue;
  data.priceCatDefs = data.pcds;
  delete data.pcds;
  data.sections = data.ss;
  delete data.ss;
  for (let i = 0; i < data.priceCatDefs.length; i++) {
    const pcd = data.priceCatDefs[i];
    pcd.color = pcd.c;
    delete pcd.c;
    pcd.currency = pcd.cu;
    delete pcd.cu;
    pcd.label = pcd.l;
    delete pcd.l;
    pcd.price = pcd.p;
    delete pcd.p;
  }
  if (data.sections != null)
    for (let i = 0; i < data.sections.length; i++) {
      data.sections[i] = getSectionDataFromMin(data.sections[i]);
    }

  return data;
}

function getSectionDataFromMin (data) {
  const section = data;
  section.noFlatSeats = section.f;
  delete section.f;
  section.graphics = section.g;
  delete section.g;
  if (section.graphics != null)
    for (let j = 0; j < section.graphics.length; j++) {
      const graphic = section.graphics[j];
      graphic.fillColor = graphic.fc;
      delete graphic.fc;
      graphic.lineColor = graphic.lc;
      delete graphic.lc;
      graphic.lineWidth = graphic.lw;
      delete graphic.lw;
      graphic.type = graphic.t;
      delete graphic.t;
      graphic.points = graphic.p;
      delete graphic.p;
      for (let k = 0; k < graphic.points.length; k++) {
        graphic.points[k].position = graphic.points[k].p;
        delete graphic.points[k].p;
      }
      graphic.flatSectionForm = graphic.fsf;
      delete graphic.fsf;
    }
  section.label = section.l;
  delete section.l;
  section.labels = section.ls;
  delete section.ls;
  if (section.labels != null)
    for (let j = 0; j < section.labels.length; j++) {
      const label = section.labels[j];
      label.label = label.l;
      delete label.l;
      label.style = label.s;
      delete label.s;
      const styles = label.style.split(';');
      const props = {};
      for (let k = 0; k < styles.length; k++) {
        const item = styles[k].split(':');
        if (item.length === 2) {
          props[item[0].trim()] = item[1].trim();
        }
      }
      label.styles = props;
    }
  section.points = section.p;
  delete section.p;
  section.row = section.r;
  delete section.r;
  section.sections = section.ss;
  delete section.ss;
  if (section.sections != null)
    for (let j = 0; j < section.sections.length; j++) {
      section.sections[j] = getSectionDataFromMin(section.sections[j]);
    }
  section.seats = section.s;
  delete section.s;
  if (section.seats != null)
    for (let j = 0; j < section.seats.length; j++) {
      const seat = section.seats[j];
      seat.priceCat = seat.p;
      delete seat.p;
      if (seat.t != null) {
        seat.ticket = { status: seat.s, id: seat.t };
        seat.ticket.userId = seat.uid;
        delete seat.uid;
      }
      delete seat.t;
      delete seat.s;
      seat.label = seat.l;
      delete seat.l;
      seat.rowLabel = seat.rl;
      delete seat.rl;
      seat.lowVisibility = seat.lv;
      delete seat.lv;
      seat.url = seat.u;
      delete seat.u;
      seat.sectorLabel = seat.sl;
      delete seat.sl;
    }
  section.type = section.t;
  delete section.t;

  return data;
}

export default {
  state,
  getters,
  mutations,
  actions
}
